module.exports = "<uch></uch>\r\n<head-title params='title:\"我的任务\"'></head-title>\r\n<user-task></user-task>";


//////////////////
// WEBPACK FOOTER
// ./src/component/userTask/userTaskIndex.html
// module id = 203
// module chunks = 0